import { StateService } from "@uirouter/angularjs";
import { IReportGroup } from "../../../../reporting/interfaces/IReportGroup";
import { IFilterFunction } from "angular";

export class ProgressiveDefinitionDetailViewController {
  static $inject = [
    "progressiveDefinition",
    "$state",
    "progressiveReportGroup",
    "currencyFilter",
  ];

  constructor(
    readonly progressiveDefinition: any,
    private readonly $state: StateService,
    readonly reportGroup: IReportGroup,
    private readonly currencyFilter: IFilterFunction
  ) {}

  clone() {
    this.$state.go("main.machines.progressives.progressiveDefinitions.add", {
      progressiveDefinition: this.progressiveDefinition,
    });
  }

  getCeilingDisplay(ceiling?: number) {
    return ceiling ? this.currencyFilter(ceiling, "$", 2) : "N/A";
  }
}
